import React, { useState } from 'react';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PlotBeingCreatedViewModel } from 'app/edozvola/cases/case-building-plot/model/case-building-plot-form.model';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import ViewTable from 'app/shared/view-table/view-table';
import {
  deletePlotBeingCreatedMutation,
  fetchAllPlotBeingCreatedQuery,
} from 'app/edozvola/cases/case-building-plot/service/case-building-plot-form.queries';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const CaseBuildingPlotBeingCreatedTable = ({ setPlotBeingCreated, setReadOnly, plotBeingFormedMarkedAsTrueAndSaved }) => {
  const { id } = useParams<{ id: string }>();
  const [idPlotBeingCreatedToDelete, setIdPlotBeingCreatedToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.PLOT_BEING_CERATED_TABLE);

  const { mutate: deletePlotBeingCreated, isPending: deletingPlotBeingCreated } = deletePlotBeingCreatedMutation();

  const openDeleteDialog = idToDelete => {
    setIdPlotBeingCreatedToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removePlotBeingCreated = () => {
    setDeleteModalShown(false);
    deletePlotBeingCreated(idPlotBeingCreatedToDelete);
  };

  const openPlotBeingCreatedForm = (idPlotBeingCreated: number, readOnly: boolean) => {
    setPlotBeingCreated(idPlotBeingCreated);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: PlotBeingCreatedViewModel, applicantIndex: number) => {
    return (
      <tr key={applicantIndex} className={invalidRowIds.includes(value.idPlotBeingCreated) ? 'invalid-table-row' : ''}>
        <td>{value.cadastralMunicipality}</td>
        <td>{value.plot}</td>
        <td>{value.beingCreatedFrom}</td>
        {plotBeingFormedMarkedAsTrueAndSaved && (
          <td>
            <div className={'actions-container'}>
              {sidebarItemPair?.canEdit && (
                <TooltipWrapper message={'Uredi'}>
                  <FontAwesomeIcon
                    icon={'pen-to-square'}
                    className={'icon-table'}
                    onClick={() => openPlotBeingCreatedForm(value.idPlotBeingCreated, false)}
                  />
                </TooltipWrapper>
              )}
              {sidebarItemPair?.canDelete && (
                <TooltipWrapper message={'Obriši'}>
                  <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idPlotBeingCreated)} />
                </TooltipWrapper>
              )}
            </div>
          </td>
        )}
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema dodanih građevnih čestica'}
        initialPaginationColumn={'cadastralMunicipality'}
        fetchDataQuery={fetchAllPlotBeingCreatedQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Katastarska općina']} width={'100px'} />
        <ViewTableHeaderColumn renderSort sortKey={'oib'} columnLabels={['Građevna čestica']} width={'100px'} />
        <ViewTableHeaderColumn renderSort sortKey={'beingCreatedFrom'} columnLabels={['Nastala iz']} width={'200px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'100px'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje građevinske čestice</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'info'} onClick={removePlotBeingCreated} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseBuildingPlotBeingCreatedTable;
